<template>
    <div>
        <page-title-farmasi heading="Detail Farmasi" :breadcrumb="[
            {
                label: 'Farmasi',
                link: '/klinik/farmasi'
            },
            {
                label: 'Detail Farmasi',
                active: true
            }
        ]">
            <template #backBtnSlot>
                <b-col sm="12" class="mb-4">
                    <router-link to="/klinik/farmasi">
                        <font-awesome-icon icon="chevron-left" size="lg" />

                    </router-link>
                </b-col>

            </template>
            <template #exampleSlot>
                <b-col sm="12" style="zoom: 80%">
                    <div class="p-4" style="width: 100%; background-color: #c1e4fb;">
                        <b-row>
                            <b-col sm="12" lg="4">
                                <div class="farmasi-info">
                                    <div>
                                        <p class="font-weight-bold text-capitalize">Nama pasien</p>
                                    </div>
                                    <div class="px-2">
                                        :
                                    </div>
                                    <div>
                                        <p class="text-capitalize">{{ pasienInfo.nama || '-' }}</p>
                                    </div>

                                </div>
                                <div class="farmasi-info">
                                    <div>
                                        <p class="font-weight-bold text-capitalize">Tanggal Lahir</p>
                                    </div>
                                    <div class="px-2">
                                        :
                                    </div>
                                    <div>
                                        <p class="text-capitalize">{{ pasienInfo.diffBirthDate || '-' }}</p>
                                    </div>
                                </div>
                                <div class="farmasi-info">
                                    <div>
                                        <p class="font-weight-bold text-capitalize">Alamat Pasien</p>
                                    </div>
                                    <div class="px-2">
                                        :
                                    </div>
                                    <div>
                                        <p class="text-capitalize">{{ 
                                            pasienInfo.fullAddress || '-'
                                        }}</p>
                                    </div>

                                </div>
                                <div class="farmasi-info" v-if="pasienInfo.jenis_kelamin == 0">
                                    <div>
                                        <p class="font-weight-bold text-capitalize">Status Ibu Hamil</p>
                                    </div>
                                    <div class="px-2">
                                        :
                                    </div>
                                    <div>
                                        <p class="text-capitalize">{{ 
                                            [0, 1].includes(pasienInfo.is_pregnant) ? (pasienInfo.is_pregnant == 1 ? 'Ya' : 'Tidak') : '-'
                                        }}</p>
                                    </div>
                                </div>
                                <div class="farmasi-info" v-if="pasienInfo.jenis_kelamin == 0">
                                    <div>
                                        <p class="font-weight-bold text-capitalize">Status Ibu Menyusui</p>
                                    </div>
                                    <div class="px-2">
                                        :
                                    </div>
                                    <div>
                                        <p class="text-capitalize">{{ 
                                            [0, 1].includes(pasienInfo.is_breastfeeding) ? (pasienInfo.is_breastfeeding == 1 ? 'Ya' : 'Tidak') : '-'
                                        }}</p>
                                    </div>
                                </div>
                            </b-col>
                            <b-col sm="12" lg="4">
                                <div class="farmasi-info">
                                    <div>
                                        <p class="font-weight-bold text-capitalize">tinggi badan pasien</p>
                                    </div>
                                    <div class="px-2">
                                        :
                                    </div>
                                    <div>
                                        <p class="text-capitalize">
                                            <template v-if="dataLoaded">
                                                {{ !pasienInfo.tinggi_badan || pasienInfo.tinggi_badan == 0 ? '-': pasienInfo.tinggi_badan + ' cm' }}
                                            </template>
                                        </p>
                                    </div>
                                </div>
                                <div class="farmasi-info">
                                    <div>
                                        <p class="font-weight-bold text-capitalize">Berat badan pasien</p>
                                    </div>
                                    <div class="px-2">
                                        :
                                    </div>
                                    <div>
                                        <template v-if="dataLoaded">
                                            <p class="text-capitalize">{{ !pasienInfo.berat_badan || pasienInfo.berat_badan == 0 ? '-': pasienInfo.berat_badan + ' kg' }}</p>
                                        </template>
                                    </div>
                                </div>
                                <div class="farmasi-info">
                                    <div>
                                        <p class="font-weight-bold text-capitalize">Alergi</p>
                                    </div>
                                    <div class="px-2">
                                        :
                                    </div>
                                    <div>
                                        <p class="text-capitalize">{{ pasienInfo.alergi_obat || '-' }}</p>
                                    </div>

                                </div>
                                <div class="farmasi-info">
                                    <div>
                                        <p class="font-weight-bold text-capitalize">Kategori Pasien</p>
                                    </div>
                                    <div class="px-2">
                                        :
                                    </div>
                                    <div>
                                        <p class="text-capitalize">{{ pasienInfo.kategori || '-' }}</p>
                                    </div>

                                </div>
                            </b-col>
                            <b-col sm="12" lg="4">
                                <div class="farmasi-info">
                                    <div>
                                        <p class="font-weight-bold text-capitalize">Nama dokter</p>
                                    </div>
                                    <div class="px-2">
                                        :
                                    </div>
                                    <div>
                                        <p class="text-capitalize">{{ pasienInfo.dokter || '-' }}</p>
                                    </div>

                                </div>
                                <div class="farmasi-info">
                                    <div>
                                        <p class="font-weight-bold text-capitalize">Poli</p>
                                    </div>
                                    <div class="px-2">
                                        :
                                    </div>
                                    <div>
                                        <p class="text-capitalize">{{ pasienInfo.poliklinik || '-' }}</p>
                                    </div>
                                </div>
                                <div class="farmasi-info">
                                    <div>
                                        <p class="font-weight-bold text-capitalize">Tanggal Konsultasi</p>
                                    </div>
                                    <div class="px-2">
                                        :
                                    </div>
                                    <div>
                                        <p class="text-capitalize">{{ pasienInfo.tanggal_konsultasi || '-'}}</p>
                                    </div>
                                </div>
                                <div class="farmasi-info">
                                    <div>
                                        <p class="font-weight-bold text-capitalize">No. Invoice</p>
                                    </div>
                                    <div class="px-2">
                                        :
                                    </div>
                                    <div>
                                        <p class="text-capitalize">{{ pasienInfo.no_invoice || '-'}}</p>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </b-col>
            </template>
        </page-title-farmasi>
        <div v-if="!isCetakLabel" class="container-fluid" style="zoom: 80%">
            <div class="card card-box  px-4">
                <b-row class="mb-4">
                    <b-col sm="12" md="6">
                        <div class="d-flex align-items-center mb-4 flex-wrap">
                            <div class="pr-0 pr-md-5 pl-md-3 pl-0" style="flex: 1;">
                                <step-progress :steps="mySteps" :current-step="currentStep" :line-thickness="6"
                                    :active-thickness="2" :passive-thickness="2" icon-class="fas fa-check"
                                    active-color="#0290ff"></step-progress>
                            </div>
                            <div style="flex-basis: 20%;">
                                <b-button v-if="currentStep < 1" @click="nextStep" variant="info" class="rounded btn-proccess">Proses</b-button>
                                <b-button v-else-if="currentStep < 2" @click="nextStep" class="rounded confirm-submit cfms">Selesai</b-button>
                            </div>
                        </div>
                    </b-col>
                    <b-col sm="12" md="6" class="d-flex justify-content-end align-items-center mb-4">
                        <b-button @click="toggleModalTelaah" variant="success" class="rounded mr-4">Telaah Resep & Obat</b-button>
                        <b-button @click="printCopyRecipe" variant="info" class="rounded btn-proccess mr-4">Cetak Resep</b-button>
                        <b-button @click="toggleModalCetakLabel" variant="primary" class="rounded">Cetak Label</b-button>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12">
                        <b-row class="mb-3">
                            <b-col sm="2" class="text-capitalize"><strong>Nama Obat & BHP</strong></b-col>
                            <b-col sm="1" class="text-capitalize"><strong>QTY</strong></b-col>
                            <b-col sm="1" class="text-capitalize"><strong>Satuan</strong></b-col>
                            <b-col sm="2" class="text-capitalize"><strong>Route</strong></b-col>
                            <b-col sm="2" class="text-capitalize"><strong>Aturan Pakai</strong></b-col>
                            <b-col sm="2" class="text-capitalize"><strong>Tanggal Kadaluarsa</strong></b-col>
                            <b-col sm="2" class="text-capitalize"><strong>Catatan</strong></b-col>
                        </b-row>
                        <b-row class="mb-3" v-for="(item, index) in pasienInfo.detail" :key="item.id">
                            <b-col sm="2">
                                <b-form-input class="input-ellipsis" :value="item.nama_layanan" v-tooltip="item.nama_layanan" disabled></b-form-input>
                            </b-col>
                            <b-col sm="1">
                                <b-form-input :value="item.quantity" disabled></b-form-input>
                            </b-col>
                            <b-col sm="1">
                                <b-form-input class="input-ellipsis" :value="!item.satuan ? '' : item.satuan.name" v-tooltip="!item.satuan ? '' : item.satuan.name" disabled></b-form-input>
                            </b-col>
                            <b-col sm="2">
                                <b-form-input class="input-ellipsis" :value="item.route_name || item.route_name_dp" v-tooltip="item.route_name || item.route_name_dp"  disabled></b-form-input>
                            </b-col>
                            <b-col sm="2">
                                <b-form-input class="input-ellipsis" :value="item.aturan_pakai" v-tooltip="item.aturan_pakai" disabled></b-form-input>
                            </b-col>
                            <b-col sm="2">
                                <!-- Date -->
                                <div style="position: relative">
                                    <DatePickerX
                                        :key="item.tanggal_kadaluarsa"   
                                        v-model="item.tanggal_kadaluarsa"
                                        locale="id"
                                        :input-props="{ placeholder: 'Pilih Tanggal', readonly: true }"
                                        @input="selectExpiredDate(item, index)"
                                    >
                                        <template v-slot="{ inputValue, inputEvents }">
                                            <b-form-input
                                                :value="inputValue"
                                                v-on="inputEvents"
                                                :readonly="true"
                                            ></b-form-input>
                                        </template>
                                    </DatePickerX>
                                    <font-awesome-icon
                                        icon="calendar"
                                        class="calendar-icon"
                                    />
                                </div>            
                            </b-col>
                            <b-col sm="2">
                                <b-form-input class="input-ellipsis" :value="item.keterangan" v-tooltip="item.keterangan" disabled></b-form-input>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </div>
        </div>
        <CetakLabel v-else :pasienInfo="pasienInfo" :selectedObat="selectedItems" @toggle="toggleViewCetakLabel">
        </CetakLabel>
        <!-- start: modal cetak label -->
        <b-modal
            title="Cetak Label"
            size="sm"
            ref="modal-cetak-label"
            button-size="sm"
            :centered="true"
            :no-close-on-backdrop="true"
            class="modal-backdrop"
        >
            <p>Pilih obat untuk dicetak label</p>
            <b-form-checkbox v-model="checkboxAll">Check Semua</b-form-checkbox>
            <div v-for="(item, index) in checkboxItems" :key="item.id">
                <b-form-checkbox v-model="selectedItems[index]" :value="item">{{ item.nama_layanan }}</b-form-checkbox>
            </div>
            <template #modal-footer>
                <b-button variant="danger" size="sm" @click="toggleModalCetakLabel">Batal</b-button>
                <b-button variant="success" size="sm" @click="clickSerahkan">Serahkan</b-button>
            </template>
        </b-modal>
        <!-- end: modal cetak label -->

        <!-- start: modal telaah -->
        <b-modal
            title="Telaah Resep & Obat"
            size="lg"
            ref="modal-telaah"
            button-size="sm"
            @hidden="onModalTelaahClosed"
            :centered="true"
            :no-close-on-backdrop="true"
            class="modal-backdrop"
        >
            <div class="row">
                <div class="col-sm-12 col-lg-6">
                    <b-form-checkbox v-model="checkboxAllResep"><span class="font-weight-bold">Telaah Resep</span></b-form-checkbox>
                    <div v-for="(item) in checkboxItemsResep" :key="item.id">
                        <b-form-checkbox v-model="selectedItemsResep" :value="item.id">{{ item.label }}</b-form-checkbox>
                    </div>
                </div>
                <div class="col-sm-12 col-lg-6">
                    <b-form-checkbox v-model="checkboxAllObat"><span class="font-weight-bold">Telaah Obat</span></b-form-checkbox>
                    <div v-for="(item) in checkboxItemsObat" :key="item.id">
                        <b-form-checkbox v-model="selectedItemsObat" :value="item.id">{{ item.label }}</b-form-checkbox>
                    </div>
                </div>
            </div>

            
            <template #modal-footer>
                <b-button variant="danger" size="sm" @click="toggleModalTelaah">Tutup</b-button>
            </template>
        </b-modal>
        <!-- end: modal telaah -->
    </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCheck, faChevronLeft, faCalendar } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";

library.add(faCheck, faChevronLeft, faCalendar)

import StepProgress from 'vue-step-progress';
import 'vue-step-progress/dist/main.css';

import CetakLabel from './CetakLabel.vue'
import { mapGetters } from 'vuex';

export default {
    components: {
        DatePickerX: () => import("v-calendar/lib/components/date-picker.umd"),
        'step-progress': StepProgress,
        CetakLabel
    },
    data() {
        return {
            mySteps: ['Proses Obat', 'Obat Siap', 'Serahkan Obat'],
            currentStep: -1,
            checkboxAll: false,
            checkboxItems: [],
            selectedItems: [],
            checkboxAllResep: false,
            checkboxItemsResep:[
                // "Tepat Identitas Pasien",
                // "Tepat Obat",
                // "Tepat Dosis",
                // "Tepat Frekuensi",
                // "Tepat Cara Pemberian",
                // "Tepat Waktu Pemberian",
                // "Duplikasi",
                // "Efek Samping Potensial",
                // "Kontradiksi"
            ],
            selectedItemsResep: [],
            checkboxAllObat: false,
            checkboxItemsObat: [
                // "Tepat Identitas Pasien",
                // "Tepat Obat",
                // "Tepat Dosis",
                // "Tepat Rute Pemberian",
                // "Tepat Waktu Pemberian"
            ],
            selectedItemsObat: [],
            initSelectedItems: [],
            pasienInfo: {},
            isCetakLabel: false,
            dataLoaded: false
        }
    },
    watch: {
        // Watch for changes in 'selectAll'
        checkboxAll: function (newValue) {
            if (newValue) {
                // If 'selectAll' is true, select all items
                this.selectedItems = [...this.checkboxItems];
            } else {
                // If 'selectAll' is false, deselect all items
                const test = []
                this.selectedItems = test
            }
        },
        checkboxAllResep: function (newValue) {
            if (newValue) {
                // If 'selectAll' is true, select all items
                this.selectedItemsResep = this.checkboxItemsResep.map((item) => item.id);
            } else {
                // If 'selectAll' is false, deselect all items
                if(this.selectedItemsResep.length == 0) {
                    const test = []
                    this.selectedItemsResep = test
                }
            }
        },
        checkboxAllObat: function (newValue) {
            if (newValue) {
                // If 'selectAll' is true, select all items
                this.selectedItemsObat = this.checkboxItemsObat.map((item) => item.id);
            } else {
                // If 'selectAll' is false, deselect all items
                if(this.selectedItemsObat.length == 0) {
                    const test = []
                    this.selectedItemsObat = test
                }
            }
        },
        selectedItems(newValue) {
            // Check if all items are selected
            const allSelected = this.checkboxItems.every((item) => newValue.includes(item));

            // Update the 'selectAll' checkbox accordingly
            this.checkboxAll = allSelected;
        },
        selectedItemsResep(newValue) {
            if (newValue.length == this.checkboxItemsResep.length) {
                this.checkboxAllResep = true;
            } else {
                this.checkboxAllResep = false;
            }
        },
        selectedItemsObat(newValue) {
            if (newValue.length == this.checkboxItemsObat.length) {
                this.checkboxAllObat = true;
            } else {
                this.checkboxAllObat = false;
            }
        },
    },
    computed: {
        ...mapGetters({
            getKlinikId: "getKlinikId",
        })
    },
    methods: {
        nextStep() {
            if (this.currentStep === 1) {
                this.$swal({
                    allowOutsideClick: false,
                    type: "warning",
                    title: 'Proses Obat Selesai',
                    text: 'Pastikan seluruh obat sudah diterima pasien',
                    confirmButtonColor: "#1791EE",
                    confirmButtonText: "Ya",
                    cancelButtonText: "Tidak",
                    showCancelButton: true,
                }).then((res) => {
                    if (res.value == true) {
                        this.currentStep = 2
                        this.prosesFarmasi(this.currentStep)
                        //redirect to list
                        // this.redirectToList();
                    } else {
                        this.currentStep = this.currentStep
                    }
                })
            } else {
                this.currentStep++
                this.prosesFarmasi(this.currentStep)
            }

        },
        async prosesFarmasi(status) {
            let id_pasien = this.$router.currentRoute.params.id;
            try {
                const payload = {
                    status: status + 1, // -1 -> 0 example
                    telaah_resep_obat: {
                        resep: this.selectedItemsResep,
                        obat: this.selectedItemsObat
                    }
                }

                let res = await this.$axios.post(`farmasi/proses_obat/${id_pasien}`, payload)
                const { success, data, data_satusehat } = res.data

                if (success) {
                    this.currentStep = data.status_bhp - 1 // 2 -> 1 example
                }

                // const isSuccess = data_satusehat.is_sync_satusehat;

                // let message = `
                //     <div style='text-align:center;'>
                //         <h3><strong>Penyerahan obat berhasil</strong></h3>
                //     </div>
                // `;

                // const title = "";
                // const text = this.pasienInfo.kewarganegaraan ==  "WNI" ? (data_satusehat.sync_satusehat_message || message) : message;
                // const text = message;
                // const type = "success";

                if (this.currentStep === 2) {
                //     this.$swal({ title, html: text, type }).then(async () => {
                        this.redirectToList();
                    // });
                }
            } catch (error) {
                // console.log(error);
            }
        },
        redirectToList() {
            this.$router.push('/klinik/farmasi');
        },
        toggleModalCetakLabel() {
            this.$refs["modal-cetak-label"].toggle("#toggle-btn");
        },
        toggleModalTelaah() {
            this.$refs["modal-telaah"].toggle("#toggle-btn");
        },
        onModalTelaahClosed() {
            console.log(this.selectedItemsResep, this.selectedItemsObat)
        },
        clickSerahkan() {
            const allNull = this.selectedItems.every((element) => element === null);

            if (allNull) {
                this.$swal({
                    allowOutsideClick: false,
                    type: "warning",
                    text: 'Silakan pilih minimal 1 obat untuk dicetak label',
                })
            } else {
                // this.toggleViewCetakLabel()
                this.toggleModalCetakLabel()

                this.createLabel()
               
            }
        },
        async getDetailFarmasi() {
            let id_pasien = this.$router.currentRoute.params.id;
            try {
                let res = await this.$axios.get(`farmasi/${id_pasien}`)
                const { success, data } = res.data

                if (success) {
                    let tambahTanggalKadaluarsa = data.detail.map((item) => {
                        item.tanggal_kadaluarsa = item.tanggal_kadaluarsa || null;
                        return item;
                    })
                    this.pasienInfo = { ...data, detail: tambahTanggalKadaluarsa}
                    this.pasienInfo.diffBirthDate = this.diffBirthDate(data.tanggal_lahir)
                    this.pasienInfo.fullAddress = this.getFullAddress(data);
                    this.currentStep = +data.status_bhp - 1 // 0 -> -1 example
                    this.checkboxItems = data.detail
                    this.checkboxItemsResep = data.checkbox_items_resep;
                    this.checkboxItemsObat = data.checkbox_items_obat;
                    this.dataLoaded = true;

                    if (data.telaah_resep_obat) {
                        const telaahResepObat = JSON.parse(data.telaah_resep_obat);
                        this.selectedItemsResep = telaahResepObat.resep;
                        this.selectedItemsObat = telaahResepObat.obat;
                    } else {
                        this.checkboxAllResep = true;
                        this.checkboxAllObat = true;
                    }
                    
                    
                }
            } catch (error) {
                // console.log(error);
            }
        },
        toggleViewCetakLabel() {
            this.isCetakLabel = !this.isCetakLabel
        },

        async createLabel() {
            try {
                const detail_obat = []

                this.selectedItems.forEach(item => {
                    if (item) {
                        detail_obat.push({
                            id: item.id
                        })
                    }
                })

                let payload = {
                    klinik_id: this.getKlinikId,
                    nama_pasien: this.pasienInfo.nama,
                    tanggal_lahir: moment(this.pasienInfo.tanggal_lahir).format('DD/MM/YYYY'),
                    no_invoice: this.pasienInfo.no_invoice,
                    tanggal_konsul: moment(this.pasienInfo.tanggal_konsultasi).format('DD/MM/YYYY'),
                    detail_obat: detail_obat
                }

                let res = await this.$axios.post(`farmasi/cetak-label`, payload, {
                    responseType: 'blob'
                })
                const blob = new Blob([res.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);

                let myWindow = window.open(url, '_blank');
                myWindow.print();
            } catch (error) {
                this.$swal({
                    allowOutsideClick: false,
                    type: "error",
                    text: error,
                })
            }
        },
        async printCopyRecipe() {
            try {
                let trans_id = this.pasienInfo.transklinik_id;
                let payload = this.pasienInfo.detail
                    .filter(v => v.kategori_layanan == 'Obat' || (v.from_bpjs == 1 && v.bpjs_sk_type == 1))
                    .map(v => ({
                        nama_layanan: v.nama_layanan || null,
                        quantity: v.quantity || null,
                        nama_satuan: v.satuan ? v.satuan.name : null,
                        route_obat_name: `${v.route_code_dp ? `${v.route_code_dp} - ` : ''}${v.route_name_dp || v.route_name || '-'}`,
                        aturan_pakai: v.aturan_pakai || null,
                        tanggal_kadaluarsa: v.tanggal_kadaluarsa || null,
                        keterangan: v.keterangan || null,
                    }));

                const res = await this.$axios.post(`copy-resep/${trans_id}?farmasi=true`, {
                    detail: payload,
                }, {
                    responseType: 'blob'
                });
                const blob = new Blob([res.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                
                let myWindow = window.open(url, '_blank');
                myWindow.print();
            } catch (error) {}
        },
        diffBirthDate(date) {
            const inputDate =date;
            const birthDate = moment(inputDate);
            const today = moment();

            // Format tanggal
            const formattedDate = birthDate.format('DD/MM/YYYY');

            // Hitung umur (durasi)
            const years = today.diff(birthDate, 'years');
            birthDate.add(years, 'years');

            const months = today.diff(birthDate, 'months');
            birthDate.add(months, 'months');

            const days = today.diff(birthDate, 'days');

            const result = `${formattedDate} (${years} tahun ${months} bulan ${days} hari)`;

            return result;
        },
        getFullAddress(data) {
            const alamatLengkap = [
                data.alamat_rumah,
                data.kelurahan_nama,
                data.kecamatan_nama,
                data.kota_nama,
                data.provinsi_nama
            ]
                .filter(Boolean) // hilangkan yang kosong/null/undefined
                .join(', ');

            return alamatLengkap;
        },
        minDate() {
            return moment().toDate();
        },
        async selectExpiredDate(item, index) {
            if (moment(item.tanggal_kadaluarsa).isBefore(this.minDate())) {
                item.tanggal_kadaluarsa = null
                this.pasienInfo.detail[index].tanggal_kadaluarsa = this.minDate();
                this.$swal({
                    allowOutsideClick: false,
                    type: "warning",
                    text: 'Expired data tidak boleh kurang dari hari ini',
                })
                return
            }
         
            try {
                const payload = {
                    id: item.id,
                    expired_date: item.tanggal_kadaluarsa
                }

                let res = await this.$axios.put(`farmasi/expired`, payload)
                const { status, data } = res.data
               
                if (status) {
                    // this.$swal({
                    //     allowOutsideClick: false,
                    //     type: "info",
                    //     text: 'Expired data berhasil diupdate',
                    // })
                    console.log('Expired data berhasil diupdate');
                }
            } catch (error) {
                // this.$swal({
                //     allowOutsideClick: false,
                //     type: "error",
                //     text: 'Expired data gagal diupdate',
                // })
                console.log(error);
            }
        }
    },

    mounted() {
        this.getDetailFarmasi()
    },
}
</script>

<style lang="scss" scoped>
.input-ellipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.calendar-icon {
    position: absolute;
    top: 13px;
    right: 10px;
}

.farmasi-info {
    display: flex;

    &>div {
        flex: 1;
        text-align: left;

        &:nth-child(2) {
            flex: 0
        }

        &:last-child {
            flex-basis: 0%;
            text-align: left;
        }
    }
}

::v-deep .step-progress__bar {
    margin-bottom: 0;
}

::v-deep .step-progress__step {

    span {
        font-size: 25px;
    }

    &:after {
        width: 50px;
        height: 50px;
    }

    &--valid {
        span {
            opacity: 1;
            color: white;
            transform: none;
            font-size: 25px;
        }
    }

    &--active {
        span {
            opacity: 1;
            color: white;
            transform: none;
            font-size: 25px;
        }

        &:after {
            color: white;
            background-color: #0290ff;
        }
    }
}

::v-deep .step-progress__step-label {
    top: calc(100% + 15px);
    font-size: 14px;
}

.cfms {
    color: white;
}

.cfms::hover {
    color: "#1791EE";
}

.btn-proccess {
    border-color: #0290ff;
    background-color: #0290ff;
}

.form-control[readonly] {
    background-color: #ffffff !important;
}
</style>

<style>
.modal-backdrop {
    opacity: 0.5 !important;
}
</style>